import React, { useState, useEffect } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, getLocalStorageKey } from "../common/common";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Snackbar from "../snackbar";
// import UploadButton from "./UploadButton";
// import UploadStatus from "./UploadStatus";
import _ from "lodash";
import { Create, TopToolbar, ListButton,useTranslate } from "react-admin";
import { useLocation, useNavigate } from 'react-router-dom';
import {
    DatePicker,
    DateTimePicker,
    TimePicker,
    MuiPickersUtilsProvider,
  } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

const LoyaltyCreate = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  // props.location.query.order_number
  const [enableSave, setEnableSave] = useState(false);

  console.log('location location',location);

  //   const [noOrderFound, setNoOrderFound] = useState(true);
  const [userList, setUserList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [userId, setUserId] = useState(null);
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");

  const [category, setCategory] = useState("");
  const [comments, setComments] = useState("");
  const [points, setPoints] = useState(null);
  // const [expiryDate, setExpiryDate] = useState(new Date());

  const [userIdError, setUserIdError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [categoryErrorMsg, setCategoryErrorMsg] = useState(null);
  const [commentsError, setCommentsError] = useState(false);
  const [commentsErrorMsg, setCommentsErrorMsg] = useState(null);
  const [pointsError, setPointsError] = useState(false);
  const [pointsErrorMsg, setPointsErrorMsg] = useState(null);


  const [balanceError, setBalanceError] = useState(false);
  const [balanceErrorMsg, setBalanceErrorMsg] = useState("");


  const [pointsAction, setPointsAction] = useState({});
  const [pointsActionError, setPointsActionError] = useState(false);
  const pointsActionOption = [
    { value: "add", label: "Add" },
    { value: "redeem", label: "Redeem" },
  ];

  const localStorageAppType = getLocalStorageKey("app_type");
  const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");

  useEffect(() => {
    if (localStorageAppType === "HOLCIM") {
      setBaseThemeColor("holcimtheme");
    } else {
      setBaseThemeColor("clickittheme");
    }
  }, [localStorageAppType]);

  useEffect(() => {
    // const { location } = props;

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/get_clickit_users`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        setUserList(jsonD.users);
        const staticUserIdList = jsonD.users;
        if ('id' in location.state) {
          const findTheUser = staticUserIdList.filter(user => user?.id == location.state?.id)
          console.log('findTheUser',findTheUser);
          setUserId(...findTheUser)
          console.log("The key 'id' exists in the object.");
        }
      });
  }, [location]);


  const cancelClick = () => {
    // setBusiness([]);
    setUserId({});
    setUserIdError(true);
    // setUserList(originalList);
  };

  const handleChangeRole = (e) => {
    console.log("hiiii", e);
    setPointsActionError(false);
    setPointsAction(e);
  };

  const handleChange = (e) => {
    console.log("hiiii", e);
    setUserIdError(false);
    setUserId(e);
  };


  const changeCategory = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setCategoryError(true);
      setCategoryErrorMsg(translate('resources.user_loyalty_points.fields.enter_category'))
    } else if (event.target.value.length > 200){
      setCategoryError(true);
      setCategoryErrorMsg(translate('resources.user_loyalty_points.fields.enter_category_below_two_hundred_characters'))
    }else {
      setCategoryError(false);
      setCategoryErrorMsg(null)
    }
    setCategory(positionObject);
  };

  const changeComments = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setCommentsError(true);
      setCommentsErrorMsg(translate('resources.user_loyalty_points.fields.enter_comments'))
    }else if (event.target.value.length > 500){
      setCommentsError(true);
      setCommentsErrorMsg(translate('resources.user_loyalty_points.fields.enter_comments_below_five_hundred_characters'))
    } else {
      setCommentsError(false);
      setCommentsErrorMsg(null);
    }
    setComments(positionObject);
  };

  const changePointsNumber = (event) => {
    const pattern = new RegExp(/^[0-9\b]+$/);
    const numberPattern = /^[0-9\b]+$/;
    const reg = new RegExp("^d+$");
    setBalanceError(false);
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length ||
      reg.test(positionObject)||
      !numberPattern.test(positionObject)
    ) {
      setPointsError(true);
      setPointsErrorMsg(translate('resources.user_loyalty_points.fields.enter_valid_points'))
    } else if(event.target.value <= 0){
      setPointsError(true);
      setPointsErrorMsg(translate('resources.user_loyalty_points.fields.enter_points_above_zero'))
    }else if(event.target.value > 100000){
      setPointsError(true);
      setPointsErrorMsg(translate('resources.user_loyalty_points.fields.enter_points_below_thousand'))
    }
    else {
      setPointsError(false);
      setPointsErrorMsg(null)
    }
    setPoints(positionObject);
  };



  const sumbitForm = () => {

    setPointsError(false);
    setPointsErrorMsg(null);
    setOnSaveDisabled(true);
    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const formData = new FormData();
    // formData.append('business', splituserId)
    formData.append("user_id", JSON.stringify(userId.id));
    formData.append("points", points);
    formData.append("category", category);
    formData.append("comments", comments);
    // formData.append("expired_at", expiryDate);
    formData.append("points_action", pointsAction.value);
    // formData.append("address", address);
    // const targetUrl = `${props.user._links.business.href}/proof_of_payments`;
    // props.addProofOfPay({ targetUrl, formData });
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";


    options.body = formData;
    fetch(`${apiUrl}/user_loyalty_points`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: userData._token,
      },
    })
      .then((res) => {
        // return res.json();
        return new Promise((resolve) =>
          res.json().then((json) =>
            resolve({
              status: res.status,
              json,
            })
          )
        );
      })
      .then(({ status, json }) => {
        // console.log(".............", json , status);
        switch (status) {
          case 400:
          case 422:
            console.log("error", json);
            setBalanceError(true);
            setBalanceErrorMsg(json.error);
            break;
          case 201:
          case 200:
            setShowSnackbar(true);
            setTimeout(() => {
              navigate(-1);
            }, 1000);
            break;
          default:
            console.log("default", status);
            break;
        }
      })
      .catch((error) => {
        console.log("error==>", error);
      });

    
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
  }, []);

  // console.log('business id offfffffff', userId);

  const CreateActions = ({ basePath, data }) => (
    <TopToolbar>
      <ListButton basePath={basePath} />
    </TopToolbar>
  );
  const translate = useTranslate();

  // {translate('resources.users.fields.updated_by_id')}
  return formSettings ? (
    <Create actions={<CreateActions />} title={translate('resources.user_loyalty_points.fields.award_redeem_loyalty_points')} {...props}>
      <div className="so-form">
        <div>
          <label className="select-label">
          {translate(baseThemeColor === 'clickittheme'? 'resources.user_loyalty_points.fields.clickit_user' : 'resources.user_loyalty_points.fields.holcim_user')}<sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              value={userId}
              onChange={handleChange}
              options={userList}
              isMulti={false}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
          </div>
          {userIdError && <p className="so-input-error">{translate(baseThemeColor === 'clickittheme'? 'resources.user_loyalty_points.fields.enter_clickit_user' : 'resources.user_loyalty_points.fields.enter_holcim_user')}</p>}
        </div>
        <div>
          <label className="select-label">
          {translate('resources.user_loyalty_points.fields.select_action')}<sup>*</sup>
          </label>
          <div className="select-retailer">
            <Select
              // value={pointsAction}
              onChange={handleChangeRole}
              options={pointsActionOption}
              isMulti={false}
              required={true}
              IndicatorsContainer={true}
            />
            {/* <button onClick={cancelClick}>{translate('resources.users.fields.clear')}</button> */}
          </div>
          {pointsActionError && <p className="so-input-error">{translate('resources.user_loyalty_points.fields.enter_select_action')}</p>}
        </div>
        <div className="so-input">
          <label>
          {translate('resources.user_loyalty_points.fields.points_to_be_awarded_redeemed')}<sup>*</sup>
          </label>
          <input
            type="number"
            min="0"
            maxLength="18"
            value={points}
            onChange={changePointsNumber}
          />
          {pointsError && (
            <p className="so-input-error">{pointsErrorMsg}</p>
          )}
          {balanceError && (
            <p className="so-input-error">{balanceErrorMsg}</p>
          )}
        </div>
        <div className="so-input">
          <label>
          {translate('resources.user_loyalty_points.fields.category_for_points_awarded_redeemed')}<sup>*</sup>
          </label>
          <input type="text" value={category} onChange={changeCategory} />
          {categoryError && <p className="so-input-error">{categoryErrorMsg}</p>}
        </div>
        <div className="so-input">
          <label>
          {translate('resources.user_loyalty_points.fields.comments_for_points_awarded_redeemed')}<sup>*</sup>
          </label>
          <textarea className="inapp-notification-description" type="text" value={comments} onChange={changeComments} />
          {commentsError && <p className="so-input-error">{commentsErrorMsg}</p>}
        </div>
        {/* <div className="promotion-date">
            <div>
              <p className="upload-files-label">
                Expiry Date<sup className="asterisk">*</sup>
              </p>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e)}
                  format="DD/MM/YYYY"
                  minDate={new Date()}
                  // maxDate={endDate}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div> */}



        <div></div>
        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={
              !category ||
              categoryError ||
              !comments ||
              commentsError ||
              !points ||
              pointsError ||
              userIdError ||
              !Object.keys(userId).length ||
              pointsActionError ||
              !Object.keys(pointsAction).length
            }
          >
            <span>{translate('resources.users.fields.save')}</span>
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
    </Create>
  ) : (
    <div>loading</div>
  );
};

export default LoyaltyCreate;
